import { render, staticRenderFns } from "./ComputacionView.vue?vue&type=template&id=1b85e29e"
import script from "./ComputacionView.vue?vue&type=script&lang=js"
export * from "./ComputacionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports